import axios from "axios";
import {axiosCatchHandler} from "../sharedGlobal";

const state = {
  loading: false,
  errors: {},
  form: {
    website: '',
    industry: '',
    country: '',
    region: '',
    location: '',
  }
};

const getters = {
  loading: ({loading}) => loading,
  errors: ({errors}) => errors,
  website: ({form}) => form.website,
  industry: ({form}) => form.industry,
  country: ({form}) => form.country,
  region: ({form}) => form.region,
  location: ({form}) => form.location,
};

const actions = {
  validateWebsite: async ({commit}, website) => {
    commit('setLoading', true);
    commit('setErrors', {});

    if (website !== '' && website === state.form.website) {
      commit('setLoading', false);
      return;
    }

    try {
      await axios.post('/ajax/website/validate', {website: website});

      commit('setLoading', false);
      commit('setWebsite', website);
    } catch (error) {
      axiosCatchHandler(error, () => {
      });

      commit('setErrors', {
        errors: error.response.data.errors,
      });

      commit('setLoading', false);
    }
  },
  setStepTwo: async ({commit}, data) => {
    commit('setIndustry', data.industry);
    commit('setCountry', data.country);
    commit('setRegion', data.region);
    commit('setLocation', data.location);

    commit('setLoading', false);
    commit('setErrors', {});
  },
  fetchLocations: async ({commit}, parentId) => {
    commit('setLoading', true);

    const {data} = await axios.post('/ajax/keyword/regions', {parent: parentId});

    commit('setLoading', false);
    return data;
  },
  create: async ({commit}) => {
    commit('setLoading', true);
    try {
      const form = state.form;
      const {data} = await axios.post('/ajax/website/store', {
        website: form.website,
        industry_gcid: form.industry,
        country_id: form.country,
        specific_location_id: form.location,
      });

      window.location.href = data.redirectUrl;
    } catch (error) {
      axiosCatchHandler(error, () => {});
      commit('setLoading', false);

      if (error.response.status === 400) {
        Swal.fire({
          icon: 'warning',
          title: 'Add website failed',
          html: error.response?.data?.message ?? 'Something went wrong, please try again later.',
        });
      }
    }
  },
  setLoading: ({commit}, loading) => commit('setLoading', loading),
  setErrors: ({commit}, errors) => commit('setErrors', errors),
};

const mutations = {
  setLoading: (state, loading) => state.loading = loading,
  setErrors: (state, errors) => state.errors = errors.errors ?? {},
  setWebsite: (state, website) => state.form.website = website,
  setIndustry: (state, industry) => state.form.industry = industry,
  setCountry: (state, country) => state.form.country = country,
  setRegion: (state, region) => state.form.region = region,
  setLocation: (state, location) => state.form.location = location,
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
